import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import appStatus from "./slices/appStatus";
import school from "./slices/school";
import ui from "./slices/ui";
import workspace from "./slices/workspace";
import auth from "./slices/auth";
import branch from "./slices/branch";
import settings from "./slices/settings";
import permission from "./slices/permission";
import role from "./slices/role";
import user from "./slices/user";
import academicYear from "./slices/academicYear";
import gradeLevel from "./slices/gradeLevel";
import classroom from "./slices/classroom";
import term from "./slices/term";
import subject from "./slices/subject";
import teacher from "./slices/teacher";
import teacherSubject from "./slices/teacherSubject";
import timeslot from "./slices/timeslot";
import curriculumRequirement from "./slices/curriculumRequirement";
import student from "./slices/student";
import enrollment from "./slices/enrollment";
import parent from "./slices/parent";
import voteHead from "./slices/voteHead";
import feeStructure from "./slices/feeStructure";
import dashboard from "./slices/dashboard";
import timetableSlot from "./slices/timetableSlot";
import timetableJob from "./slices/timetableJob";
import timetable from "./slices/timetable";
import supplier from "./slices/supplier";
import inventoryItem from "./slices/inventoryItem";
import inventoryLog from "./slices/inventoryLog";
import stockLevel from "./slices/stockLevel";
import smsTemplate from "./slices/smsTemplate";
import smsOutbox from "./slices/smsOutbox";
import feeAllocation from "./slices/feeAllocation";
import studentFeeLedger from "./slices/studentFeeLedger";
import announcement from "./slices/announcement";
import notification from "./slices/notification";
import purchaseOrder from "./slices/purchaseOrder";
import attendanceRecord from "./slices/attendanceRecord";
import assessment from "./slices/assessment";
import assessmentScore from "./slices/assessmentScore";
import studentTermReport from "./slices/studentTermReport";
import newsletter from "./slices/newsletter";
import transitionRecord from "./slices/transitionRecord";
import bankTransactionStaging from "./slices/bankTransactionStaging";
import auditLog from "./slices/auditLog";
import unallocatedPayment from "./slices/unallocatedPayment";
import payment from "./slices/payment";

const rootReducer = combineReducers({
  appStatus,
  school,
  ui,
  workspace,
  auth,
  branch,
  settings,
  permission,
  role,
  user,
  academicYear,
  gradeLevel,
  classroom,
  term,
  subject,
  teacher,
  teacherSubject,
  timeslot,
  curriculumRequirement,
  student,
  enrollment,
  parent,
  voteHead,
  feeStructure,
  dashboard,
  timetableSlot,
  timetableJob,
  timetable,
  supplier,
  inventoryItem,
  inventoryLog,
  stockLevel,
  smsTemplate,
  smsOutbox,
  feeAllocation,
  studentFeeLedger,
  announcement,
  notification,
  purchaseOrder,
  attendanceRecord,
  assessment,
  assessmentScore,
  studentTermReport,
  newsletter,
  transitionRecord,
  bankTransactionStaging,
  auditLog,
  unallocatedPayment,
  payment,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Strongly typed custom hooks for React components
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
